module.exports = __webpack_public_path__ + "img/flower-blue.204a70a5.png";